'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('eb_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('eb_cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('eb_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm z-50"
    >
      <div className="bg-white border border-[rgba(27,67,50,0.12)] rounded-2xl shadow-lg p-5">
        {/* Title: #0D1F17 on #FFFFFF = 17.14:1 ✓ */}
        <p className="text-sm font-medium mb-1" style={{ color: '#0D1F17', fontFamily: 'var(--font-body)' }}>
          We use cookies 🍪
        </p>
        {/* Body: #5c6b63 on #FFFFFF = 5.62:1 ✓ */}
        <p className="text-xs leading-relaxed mb-4" style={{ color: '#5c6b63', fontFamily: 'var(--font-body)' }}>
          We use cookies to improve your experience and analyze site usage. See our{' '}
          {/* Link: #2d7a54 on #FFFFFF = 5.22:1 ✓ */}
          <Link href="/privacy-policy" className="underline underline-offset-2 hover:opacity-80 transition-opacity" style={{ color: '#2d7a54' }}>
            Privacy Policy
          </Link>{' '}
          for details.
        </p>
        <div className="flex gap-2">
          {/* Accept: white on #1B4332 = 11.08:1 ✓ */}
          <button
            onClick={handleAccept}
            className="flex-1 text-xs font-semibold py-2 px-4 rounded-lg transition-colors"
            style={{ background: '#1B4332', color: '#ffffff', fontFamily: 'var(--font-body)' }}
          >
            Accept
          </button>
          {/* Decline: #1B4332 on #FFFFFF = 11.08:1 ✓ */}
          <button
            onClick={handleDecline}
            className="flex-1 text-xs font-semibold py-2 px-4 rounded-lg border transition-colors hover:bg-[#1B4332] hover:text-white"
            style={{ background: '#ffffff', color: '#1B4332', borderColor: 'rgba(27,67,50,0.25)', fontFamily: 'var(--font-body)' }}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
